module.exports = __webpack_public_path__ + "2d52380b8a401d8d351b0d316f6f8643.svg";